import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GDPRManager } from './../../managers/gdpr.manager';
import { SharedService } from './../../shared';
import { TEXT, MESSAGES } from './../../app.const';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
  public isValid: Boolean = false;
  public TEXT = TEXT;
  public showBanner: Boolean = true;

  constructor(public router: Router, private route: ActivatedRoute, public mgr: GDPRManager, public sharedService: SharedService) {
    this.getDeviceType();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mgr.handleRoute(params);
    });
  }

  getDeviceType() {
    if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      this.showBanner = false;
    }
  }

  handleCorrectCaptcha(token) {
    this.sharedService.showLoader = true;
    if (!!token) {
      this.mgr.setGToken(token);
      this.mgr.exchangeToken().then((res) => {
        this.sharedService.showLoader = false;
        if (res && res['token']) {
          this.mgr.setZToken(res['token']);
          this.isValid = true;
        }
      }).catch((err) => {
        console.log(err);
        this.sharedService.showLoader = false;
        this.sharedService.displayErrorMsg(MESSAGES.ERROR);
      });
    }
  }
  getDetailsPage() {
    this.router.navigate(['/home'], {
      queryParams: this.mgr.getParams()
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/authentication/authentication.component.ts